import React from "react";
import { Mui } from "../../libraries/material";

const Drugs = Mui.createSvgIcon(
  <g
    id="Artboard"
    transform="translate(-729.000000, -38.000000)"
    fill="currentColor"
    fillRule="nonzero"
  >
    <g id="drugs" transform="translate(729.000000, 38.000000)">
      <rect
        id="Rectangle"
        opacity="0"
        x="4.23651821e-07"
        y="0"
        width="23.9999996"
        height="20.8936632"
      ></rect>
      <path
        d="M24,14.8017354 C23.6434155,12.2142808 21.4124585,10.2074279 18.7129519,10.2074279 C16.0133583,10.2074279 13.7925721,12.2142808 13.4359875,14.8017354 L24,14.8017354 Z M24,16.289098 L13.4359875,16.289098 C13.8027428,18.8868103 16.0133583,20.8936632 18.7129519,20.8936632 C21.4328869,20.8936632 23.6434155,18.8868103 24,16.289098 Z"
        id="Shape"
        fillOpacity="0.85"
      ></path>
      <path
        d="M11.7653777,11.1038443 L14.96412,7.90514536 C16.8690916,6.01035319 16.8996039,3.55527474 15.0863428,1.75216705 C13.2628241,-0.0611222579 10.8179338,-0.0101870865 8.93339059,1.87441591 L5.73462214,5.07314958 L11.7653777,11.1038443 Z M10.695711,12.1836817 L4.65479341,6.14279018 L1.45605974,9.3516946 C-0.448914472,11.2464955 -0.479475383,13.7015565 1.33381957,15.5046468 C3.15729483,17.3179948 5.60218515,17.2772249 7.48678919,15.3925948 L10.695711,12.1836817 Z"
        id="Shape"
        fillOpacity="0.85"
      ></path>
    </g>
  </g>,
  "other drug use"
);

export default Drugs;
